import { render } from "./ComponentDetailUser.vue?vue&type=template&id=e755021e&scoped=true"
import script from "./ComponentDetailUser.vue?vue&type=script&lang=js"
export * from "./ComponentDetailUser.vue?vue&type=script&lang=js"

import "./ComponentDetailUser.vue?vue&type=style&index=0&id=e755021e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e755021e"]])

export default __exports__